export var contactFormURL = "https://www.piab.com/support/contact-us?utm_medium=website&utm_source=piab&utm_campaign=va_global_digital&utm_content=ovm_pro_contactus";
export var authRedirectURL = "https://piab.com/partner-login-page";
export var returnPathQueryKey = "returnPath";
export var tokenQueryKey = "token";
